import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5588996762222'; // Formato: código do país + DDD + número
    const message = encodeURIComponent(
      'Olá! Gostaria de saber mais sobre os móveis de luxo. Vim através do site.'
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      data-testid="whatsapp-button"
      className="fixed bottom-6 left-6 z-50 w-16 h-16 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#20BA5A] transition-all duration-500 hover:scale-110 group"
      aria-label="Abrir WhatsApp"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={1.5} fill="currentColor" />
      
      {/* Tooltip */}
      <div className="absolute bottom-20 left-0 bg-primary text-white px-4 py-2 text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Fale conosco no WhatsApp
      </div>
    </button>
  );
};

export default WhatsAppButton;